module.exports = __webpack_public_path__ + "static/media/16.9116d479.png";